import { IUpdateFeriasUseCase } from "../../../presentation/useCases/update/update_ferias_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateFeriasUseCase
 */

export class UpdateFeriasUseCase implements IUpdateFeriasUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async updateFerias(
    idFuncionarioFerias: number,
    descricao: string,
    dataInicio: Date,
    dataTermino: Date,
  ): Promise<void> {
    await this.repository.updateFerias(
      idFuncionarioFerias,
      descricao,
      dataInicio,
      dataTermino,
    );
  }
}